import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import Select from 'react-select';
import type { SelectedShipmentMethod, DynamicsBcShipmentMethod } from '../invoice/types';
import type { DynamicsBcSettingsModuleProps } from '@src/pages/settings/types';
import { allShipmentMethods } from '@src/Api';

export const DynamicsBcDefaultShipmentMethod: React.FC<DynamicsBcSettingsModuleProps> = ({
    dynamicsBcUserDefaultData,
    setDynamicsBcUserDefaultData
}) => {
    const [shipmentMethods, setShipmentMethods] = React.useState<DynamicsBcShipmentMethod[]>([]);

    React.useEffect(() => {
        const fetchShipmentMethods = async () => {
            try {
                const shipmentMethodResponse = await allShipmentMethods();
                if (shipmentMethodResponse && Array.isArray(shipmentMethodResponse.data)) {
                    setShipmentMethods(shipmentMethodResponse.data);
                } else {
                    setShipmentMethods([]);
                }
            } catch (error) {
                console.error('Failed to fetch shipment methods:', error);
                setShipmentMethods([]);
            }
        };

        fetchShipmentMethods();
    }, []);

    const handleShipmentMethodChange = (selectedOption: SelectedShipmentMethod | null) => {
        if (!setDynamicsBcUserDefaultData) {
            return;
        }

        if (!selectedOption) {
            const defaultDataWithoutShipmentMethod = { ...dynamicsBcUserDefaultData };
            delete defaultDataWithoutShipmentMethod.customer_shipment_method;
            setDynamicsBcUserDefaultData(defaultDataWithoutShipmentMethod);
            return;
        }

        setDynamicsBcUserDefaultData({
            ...dynamicsBcUserDefaultData,
            customer_shipment_method: {
                shipmentMethodCode: selectedOption.shipmentMethodCode,
                shipmentMethodId: selectedOption.shipmentMethodId
            },
        });
    };

    const shipmentMethodOptions = shipmentMethods.map((shipmentMethod) => ({
        shipmentMethodId: shipmentMethod.id,
        shipmentMethodCode: shipmentMethod.code,
        label: shipmentMethod.displayName
    }));

    return (
        <Form.Group as={Row} className="mb-3" controlId="formHorizontalShipmentMethod">
            <Form.Label column sm={6}>
                Default shipment method for new customers
            </Form.Label>
            <Col sm={6} className="custom-z-index-shipment">
                <Select
                    classNamePrefix="react-select"
                    aria-label="Default shipment method for new customers"
                    value={shipmentMethodOptions.find((option) => option.shipmentMethodId === dynamicsBcUserDefaultData.customer_shipment_method?.shipmentMethodId)}
                    onChange={handleShipmentMethodChange}
                    options={shipmentMethodOptions}
                    isClearable
                    placeholder="Use Business Central customer default"
                />
            </Col>
        </Form.Group>
    );
};
